import React from 'react';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '@/components/ui/accordion';

/** Build FAQPage JSON-LD from a list of {q, a}. */
export function buildFaqSchema(faqs = []) {
  const valid = (faqs || []).filter((f) => f?.q && f?.a);
  if (!valid.length) return null;
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: valid.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };
}

export default function FAQ({ title = 'Česta pitanja', subtitle, faqs = [] }) {
  if (!faqs.length) return null;
  return (
    <section className="section-pad bg-slate-50" data-testid="faq-section">
      <div className="container-x max-w-3xl">
        <div className="text-center">
          <span className="tag-pill">FAQ</span>
          <h2 className="font-display text-4xl sm:text-5xl font-bold mt-4">{title}</h2>
          {subtitle && <p className="text-slate-600 mt-4 text-lg">{subtitle}</p>}
        </div>
        <Accordion type="single" collapsible className="mt-10 space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-white border border-slate-200 rounded-2xl px-5 shadow-sm"
            >
              <AccordionTrigger className="text-left font-semibold text-slate-900 hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
